import './room-content.scss'
import _ from 'lodash'
import anime from 'animejs'
import { loadSvg } from 'js/utility/image.js'

export const component = {
    name: 'room-content',

    data: {
        bookPosition: 'scroll',
        dateStart: null,
        dateEnd: null,
        // dateRange: null,
        gallery: null,
        people: 1,
        children: 0
    },

    watch: {
        'bookScroll.topVisible': function (visible) {
            this.bookScrollPosition()
        },

        'bookScroll.bottomVisible': function (visible) {
            this.bookScrollPosition()
        },

        dateStart(value) {
            if (this.dateEnd === null) {
                this.dateEnd = value
            }
        },

        dateEnd(value) {
            if (value && this.dateStart) {
                if (value < this.dateStart) {
                    this.dateEnd = null
                }
            }
        }
    },

    mounted () {
        // map
        this.googleMap()

        // lightbox
        this.gallery = new LuminousGallery(this.$refs.imagesGrid.querySelectorAll('a'))

        // service icons
        _.each(this.room.services, service => {
            if (service.image_url) {
                Promise.resolve()
                    .then(() => loadSvg(service.image_url))
                    .then(svg => { service.icon = svg.outerHTML })
            }
        })

        // scroll listener
        if (!this.isSmallScreen()) {
            window.addEventListener('scroll', this.bookScrollListener)
        }
    },

    methods: {
        isSmallScreen() {
            const mqset = window.theme.mediaquery.get()
            const small = _.find(mqset, mqobj => mqobj.name === 'small')
            const medium = _.find(mqset, mqobj => mqobj.name === 'medium')
            return (small.mql.matches || medium.mql.matches)
        },

        googleMap () {
            if (!window.google) {
                setTimeout(() => this.googleMap(), 1000)
                return
            }
            const position = {
                lat: parseFloat(this.room.accommodation.position.lat),
                lng: parseFloat(this.room.accommodation.position.lng)
            }

            this.map = new google.maps.Map(this.$refs.map, {
                center: position,
                zoom: 16
            })

            new google.maps.Marker({
                position,
                map: this.map
            })
        },

        bookScrollListener () {
            const columnRect = this.$refs.bookColumn.getBoundingClientRect()
            const wrapperRect = this.$refs.bookWrapper.getBoundingClientRect()

            if (columnRect.top <= 0 && (columnRect.bottom - wrapperRect.height) >= 0) {
                if (this.bookPosition !== 'fixed') {
                    this.bookPosition = 'fixed'
                }
            } else {
                if ((columnRect.bottom - wrapperRect.height) < 0) {
                    this.bookPosition = 'scroll-bottom'
                } else {
                    this.bookPosition = 'scroll'
                }
            }
        },

        scrollTo (section) {
            let el = null
            switch (section) {
                case 'description':
                    el = this.$refs.descriptionSection
                    break
                case 'images':
                    el = this.$refs.imagesSection
                    break
                case 'services':
                    el = this.$refs.servicesSection
                    break
                case 'map':
                    el = this.$refs.mapSection
                    break
            }
            const top = el.getBoundingClientRect().top
            const obj = { top: window.pageYOffset }
            anime({
                targets: obj,
                top: [window.pageYOffset, window.pageYOffset + top - 24],
                duration: 500,
                easing: 'easeInOutSine',
                update: () => {
                    window.requestAnimationFrame(() => {
                        window.scrollTo(0, obj.top)
                    })
                }
            })
        },

        submit () {
            if (!(this.dateStart && this.dateEnd)) {
                return
            }

            let from = this.dateStart
            let to = this.dateEnd

            if (this.room.accommodation.booking_engine === 'fullboard') {
                if (!from) {
                    return
                } else {
                    from = `${from.getDate()}-${from.getMonth() + 1}-${from.getFullYear()}`
                }

                if (!to) {
                    return
                } else {
                    to = `${to.getDate()}-${to.getMonth() + 1}-${to.getFullYear()}`
                }

                let url = `http://${this.room.accommodation.booking_account_name}.fullboard.cloud/booking/prenota-hotel/${this.room.accommodation.booking_id}_struttura.html?checkFilter=true&data_checkin=${from}&data_checkout=${to}&n_camere=1&room_number=1&n_adulti=${this.people}&n_bambini=${this.children}&trattamento=struttura`
                window.open(url, '_blank')
            }

            if (this.room.accommodation.booking_engine === '5 stelle') {
                if (!from) {
                    return
                } else {
                    from = [from.getFullYear().toString(), (from.getMonth() + 1).toString(), from.getDate().toString()]
                    from[1] = (from[1].length === 1) ? '0' + from[1] : from[1]
                    from[2] = (from[2].length === 1) ? '0' + from[2] : from[2]
                    from = from.join('-')
                }

                if (!to) {
                    return
                } else {
                    to = [to.getFullYear().toString(), (to.getMonth() + 1).toString(), to.getDate().toString()]
                    to[1] = (to[1].length === 1) ? '0' + to[1] : to[1]
                    to[2] = (to[2].length === 1) ? '0' + to[2] : to[2]
                    to = to.join('-')
                }

                let url = `https://secure.kosmosol.it/booking/v2/check-availability.php?h=${this.room.accommodation.booking_name}&l=${this.currentLanguage}&bd=${from}&ed=${to}`
                window.open(url, '_blank')
            }
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/room-content/room-content.js